import project1 from "../Zimages/projects/project1.jpg";
import project2 from "../Zimages/projects/project2.jpg";
import project3 from "../Zimages/projects/project3.jpg";
import project4 from "../Zimages/projects/project4.jpg";
import project5 from "../Zimages/projects/project5.jpg";
// import project6 from "../Zimages/projects/project6.jpg";

const projectsData = [
  {
    id: "1",
    service: "Property Management",
    name: "Al Dana Residential Building",
    location: "Doha, Qatar",
    image: project1
  },

  {
    id: "2",
    service: "Property Management",
    name: "Siraj Tower",
    location: "Arjan, UAE",
    image: project2
  },

  {
    id: "3",
    service: "Property Management",
    name: "Scala Tower",
    location: "Dubai",
    image: project3
  },

  {
    id: "4",
    service: "Property Management",
    name: "Industrial Complex",
    location: "Doha, Qatar",
    image: project4
  },

  {
    id: "5",
    service: "Property Management",
    name: "Burj View",
    location: "Arjan, UAE",
    image: project5
  },

  // {
  //   id: "6",
  //   service: "Property Management",
  //   name: "Al Madar Office Building",
  //   location: "Dubai",
  //   image: project6
  // },

  // {
  //   id: "7",
  //   service: null,
  //   name: null,
  //   location: null,
  //   image: null
  // },

  // {
  //   id: "8",
  //   service: null,
  //   name: null,
  //   location: null,
  //   image: null
  // },

  // {
  //   id: "9",
  //   service: null,
  //   name: null,
  //   location: null,
  //   image: null
  // },

  // {
  //   id: "10",
  //   service: null,
  //   name: null,
  //   location: null,
  //   image: null
  // },
  
              
];

export default projectsData